export default "__VITE_ASSET__C0wPGk4P__"